import { render, staticRenderFns } from "./PreviousData.vue?vue&type=template&id=17089b3a&scoped=true&"
import script from "./PreviousData.vue?vue&type=script&lang=js&"
export * from "./PreviousData.vue?vue&type=script&lang=js&"
import style0 from "./PreviousData.vue?vue&type=style&index=0&id=17089b3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17089b3a",
  null
  
)

export default component.exports